import Form from "../Form/Form";
import css from "./AddEquipment.module.css";
import SalesStarlinkEquipmentOptions from "./SalesStarlinkEquipmentOptions";
import Url from "../../Services/Url";
import { Get } from "../../Services/Server";
import { useState } from "react";

const AddSalesEquipment = ({ onSubmit }) => {
	const [options, setOptions] = useState(SalesStarlinkEquipmentOptions);
	const init = () => {
		const op = { ...options };
		op.Fields[0].value = "";
		op.Fields[1].value = "";
		op.Fields[2].value = "";
		setOptions(op);
	};
	const countryChange = (e) => {
		if (typeof e === "object" && e != null) {
			Get(Url.contract.getContractByCountry(e.id))
				.then((resp) => {
					const op = { ...options };
					op.Fields[3].options = resp;
					setOptions(op);
				})
				.catch((err) => {});
		}
	};
	options.Fields[2].onSelected = countryChange;

	const handleSubmit = () => {
		onSubmit && onSubmit(options);
		init();
	};

	return (
		<div className={css.AddEquipment}>
			{options && <Form onSubmit={handleSubmit}>{options}</Form>}
		</div>
	);
};

export default AddSalesEquipment;
